const hrEn = {
    department: require('../../lang/en/hr/Department').default,
    employee: require('../../lang/en/hr/Employee').default,
    group: require('../../lang/en/hr/Group').default,
    groupType: require('../../lang/en/hr/GroupType').default,
};

export default hrEn;